module.exports = __webpack_public_path__ + "static/media/btn2.f4cdc5c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/btn2.png
// module id = 1642
// module chunks = 0